// Copyright (c) 2016 Deere & Company

import {fetchQuestionablePartReport, resetQuestionablePart} from './report';
import {sharedActionCreators} from '../../shared/action-creators';
import {updateQuestionablePartSearchCriteria} from './criteria';

export default {
    fetchQuestionablePartReport,
    resetQuestionablePart,
    updateQuestionablePartSearchCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/action-creators/index.js